import {isEmpty} from 'front-onceforall-core/dist/utils/arrays';
import {I18n} from 'react-redux-i18n';

const TRAD_ROOT = 'project.requiredDocuments.tooltip';

const getBusinessLinesTranslations = businessLines => (
  businessLines
    .map(el => I18n.t(`organisation.businessLine.${el}`))
    .join(', ')
);
export const getBusinessLineTooltip = type => {
  if (type.organisationScope === 'FOREIGN') {
    return I18n.t(`${TRAD_ROOT}.FOREIGN`);
  }
  if (isEmpty(type?.businesses)) {
    return '';
  }
  const message = I18n.t(`${TRAD_ROOT}.businessLines`, {count: type?.businesses?.length});
  const businessLines = getBusinessLinesTranslations(type?.businesses);
  return `${message}${businessLines}`;
};
